// src/components/resources/quizzes/components/Navigation.tsx

'use client'

import { Button } from '~/components/ui/Button'
import { cn } from '~/lib/utils'
import type { NavigationProps } from '~/components/resources/quizzes/types/quiz-types'

export function Navigation({
  canNavigateBack,
  canNavigateForward,
  onBack,
  onNext,
  className
}: NavigationProps): JSX.Element {
  return (
    <div className={cn('flex justify-between gap-4', className)}>
      <Button
        variant="outline"
        onClick={onBack}
        disabled={!canNavigateBack}
        className="w-[120px]"
      >
        Previous
      </Button>
      <Button
        onClick={onNext}
        disabled={!canNavigateForward}
        className="w-[120px]"
      >
        Next
      </Button>
    </div>
  )
} 